import { useEffect, useState } from 'react';
import { Form, Row, Col } from 'react-bootstrap';
import axios from 'axios';
import config from '../../../config';
import Select from 'react-select';

function BrokerMaterialSupplyForm({ form, setForm, stepSubmitted }) {
    const [products, setProducts] = useState([]);
    const [packagingMaterials, setPackagingMaterials] = useState([]);

    useEffect(() => {
        const fetchProducts = async () => {
            try {
                const res = await axios.get(`${config.API_BASE_URL}/products`);
                setProducts(res.data || []);
            } catch (err) {
                console.error('Failed to fetch products:', err);
            }
        };

        const fetchPackagingMaterials = async () => {
            try {
                const res = await axios.get(`${config.API_BASE_URL}/packing-materials`);
                setPackagingMaterials(res.data || []);
            } catch (err) {
                console.error('Failed to fetch packaging materials:', err);
            }
        };

        fetchProducts();
        fetchPackagingMaterials();
    }, []);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setForm((prev) => ({ ...prev, [name]: value }));
    };

    // const handleMultiSelectChange = (e) => {
    //     const selectedOptions = Array.from(e.target.selectedOptions).map(
    //         (option) => option.value
    //     );
    //     setForm((prev) => ({ ...prev, material_supplied: selectedOptions }));
    // };

    // Map products and packaging materials into the format required by react-select
    const productOptions = products.map((product) => ({
        value: product._id,
        label: product.productName,
    }));

    const packagingOptions = packagingMaterials.map((material) => ({
        value: material._id,
        label: `${material.name} (${material.alias})`,
    }));

    // Handle multi-select changes
    const handleProductChange = (selectedOptions) => {
        const currentMaterials = form.material_supplied || [];
        // Remove existing products and add new ones
        const filteredMaterials = currentMaterials.filter(m => m.material_type !== 'Product');
        const newProducts = selectedOptions.map(opt => ({
            material_id: opt.value,
            material_type: 'Product'
        }));
        setForm((prev) => ({
            ...prev,
            material_supplied: [...filteredMaterials, ...newProducts],
        }));
    };

    const handlePackagingChange = (selectedOptions) => {
        const currentMaterials = form.material_supplied || [];
        // Remove existing packaging materials and add new ones
        const filteredMaterials = currentMaterials.filter(m => m.material_type !== 'PackingMaterial');
        const newPackaging = selectedOptions.map(opt => ({
            material_id: opt.value,
            material_type: 'PackingMaterial'
        }));
        setForm((prev) => ({
            ...prev,
            material_supplied: [...filteredMaterials, ...newPackaging],
        }));
    };

    // Get selected values for display
    const selectedProducts = productOptions.filter((opt) =>
        (form.material_supplied || []).some(m => m.material_type === 'Product' && m.material_id === opt.value)
    );

    const selectedPackaging = packagingOptions.filter((opt) =>
        (form.material_supplied || []).some(m => m.material_type === 'PackingMaterial' && m.material_id === opt.value)
    );

    return (
        <div className="mb-4">
            <Row>
                <Col md={12}>
                    <Form.Group className="mb-3 fs-9">
                        <Form.Label>Products</Form.Label>
                        <Select
                            isMulti
                            options={productOptions}
                            value={selectedProducts}
                            onChange={handleProductChange}
                            placeholder="Select products..."
                        />
                    </Form.Group>
                </Col>
                <Col md={12}>
                    <Form.Group className="mb-3 fs-9">
                        <Form.Label>Packaging Materials</Form.Label>
                        <Select
                            isMulti
                            options={packagingOptions}
                            value={selectedPackaging}
                            onChange={handlePackagingChange}
                            placeholder="Select packaging materials..."
                        />
                    </Form.Group>
                </Col>
                <Col md={12}>
                    <Form.Group className="mb-2">
                        <Form.Label>Other Services</Form.Label>
                        <Form.Control
                            name="other_services"
                            value={form.other_services}
                            onChange={handleChange}
                            placeholder="Enter any custom services like solar, etc."
                        />
                    </Form.Group>
                </Col>
            </Row>
        </div>
    );
}

export default BrokerMaterialSupplyForm;
